import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const EventList = ({ runId }) => {

  const { state } = useLocation();
  const isApprover = state?.isApprover;
  
  const { principal } = usePrincipal();
  const username = principal.username;

  const augRowsReq = useCallback((rowsReq) => {
    if (runId) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('runId', runId));
    }

    if (isApprover !== undefined) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('type', 'APPR_REQ'));
      if (isApprover === false) {
        // My Requests
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('recBy', username))
      } else {
        // Pending Approvals
        rowsReq.query = 'APPR_EVENTS';
        rowsReq.replaceParams = { username: username };
      }
    }
  }, [runId, username, isApprover]);

  return (
    <EntityList
      module="skdr"
      entity="EVENT"
      augRowsReq={augRowsReq}
    />
  );

}